import { IAgreementRepository, GeoJsonValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class AgreementRepository implements IAgreementRepository {
  async getByAmbit(filters: any): Promise<GeoJsonValueObject> {
    const response = await axiosClient.post<GeoJsonValueObject>('/agreements/ambit', filters);
    return response.data;
  }
}
